let __flarum_default_export__;
import app from 'flarum/forum/app';
export default __flarum_default_export__ = async () => {
  if (app.session.user) {
    return;
  }

  // `app.request` only returns the body, but headers are needed here.
  const res = await fetch(`${app.forum.attribute('apiUrl')}/lscache-csrf`);
  const token = res.headers.get('X-CSRF-Token');
  if (token) {
    app.session.csrfToken = token;
  }
};
flarum.reg.add('acpl-lscache', 'forum/utils/updateCSRF', __flarum_default_export__);